module.exports = __webpack_public_path__ + "static/media/18_Ai_C@3x.ba58f8d2.jpg";